export type Params = (...args: any[]) => void;
export const debounceFn = <F extends Params>(callbackFn: F, timeOut: number) => {
  let timeoutId: number | undefined = undefined;
  return (...args: Parameters<F>) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callbackFn(...args);
    }, timeOut);
  };
}